'use es6';

import * as Features from 'self-service-api/constants/Features';
import * as ProductLines from 'self-service-api/constants/ProductLines';
export default {
  [ProductLines.SALES]: [Features.CONTACT_MANAGEMENT, Features.EMAIL_SCHEDULING, Features.DEAL_PIPELINE, Features.MEETINGS, Features.LIVE_CHAT],
  [ProductLines.MARKETING]: [Features.FORMS, Features.EMAIL_MARKETING, Features.AD_MANAGEMENT, Features.LIVE_CHAT, Features.REPORTING_DASHBOARDS],
  [ProductLines.SERVICE]: [Features.TICKETING, Features.LIVE_CHAT, Features.CONVERSATIONS_INBOX, Features.CONVERSATIONAL_BOTS, Features.MOBILE_APP],
  [ProductLines.OPERATIONS]: [Features.DATA_SYNC, Features.HISTORICAL_SYNC, Features.DEFAULT_FIELD_MAPPINGS],
  [ProductLines.CMS]: [Features.WEBSITE_PAGES, Features.BLOG, Features.DRAG_AND_DROP_EDITOR, Features.WEBSITE_TRAFFIC_ANALYTICS]
};